import React, { FC, useContext } from 'react';
import { Wrapper } from './styled';
import { Avatar, Button, Flex, Space, Tooltip } from 'antd';
import { UserContext } from '../../services/contexts';
import { Text } from '../../theme/typography';
import { COLORS, TYPOGRAPHY_SIZES } from '../../theme';
import { IoMdLogOut } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../redux/slices/auth';

const Header: FC = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [logout] = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logout().unwrap();
    } catch (e) {
      console.log('logout failed');
    }
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify(false));
    } catch (e) {
      console.log('unautheticated');
    }

    navigate('/login');
  };
  const displayName = user.displayName || user.name || user.email || 'User';
  const initials = displayName
    .trim()
    .split(/\s+/)
    .map(part => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Wrapper>
      <Flex justify={'end'}>
        <Space>
          <Avatar style={{ backgroundColor: '#87d068' }}>{initials}</Avatar>
          <Text size={TYPOGRAPHY_SIZES.NORMAL} color={COLORS.white} weight={600}>
            {displayName}
          </Text>
          <Tooltip title="Logout">
            <Button
              type="text"
              shape="circle"
              icon={<IoMdLogOut color={COLORS.white} />}
              onClick={handleLogout}
            />
          </Tooltip>
        </Space>
      </Flex>
    </Wrapper>
  );
};

export default Header;
